import { useAppDispatch, useAppSelector } from "@/config/store";
import { Avatar, Card, List, ListItem, ListItemIcon, ListItemText, Pagination } from "@/components/ui";
import { IEdoFriendship } from "@/shared/model/edo-friendship.model";
import { getCurrentUserFriendships } from "@/shared/reducers/entities/edo-friendship.reducer";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { ITEMS_PER_PAGE } from "@/shared/util/pagination.constants";
import { useEffect, useState } from "react";
import { IPaginationBaseState, Translate } from "react-jhipster";

interface FriendsListProps {
  roleFilter: string | null;
  title: string;
}

const FriendsList = (props: FriendsListProps) => {
  const dispatch = useAppDispatch();
  const [paginationState, setPaginationState] = useState<IPaginationBaseState>({
    activePage: 1,
    itemsPerPage: ITEMS_PER_PAGE,
    sort: "createdAt",
    order: "ASC",
  });
  const { entities: friendships, totalItems } = useAppSelector<
    EntityState<IEdoFriendship>
  >((state) => state.edoFriendship);

  const { roleFilter, title } = props;

  const handleGetFriendships = () => {
    dispatch(
      getCurrentUserFriendships({
        page: paginationState.activePage,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
        ...(roleFilter ? { role: roleFilter } : {}),
      })
    );
  };

  const handlePagination = (currentPage: number) =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleRowsPerPage = (rowsPerPage: number) =>
    setPaginationState({
      ...paginationState,
      itemsPerPage: rowsPerPage,
      activePage: 1,
    });

  useEffect(() => {
    handleGetFriendships();
  }, [
    roleFilter,
    paginationState.activePage,
    paginationState.order,
    paginationState.sort,
    paginationState.itemsPerPage,
  ]);

  return (
    <Card className="surface grid overflow-hidden rounded-3xl grid-rows-[min-content_auto_min-content] h-full p-0">
      <div className="border-b border-[var(--color-mockup-border)] bg-[var(--color-surface-secondary)]/50 px-4 py-3 dark:border-[var(--color-mockup-border)] dark:bg-[var(--color-surface-secondary)]/30">
        <h2 className="text-heading font-semibold text-[var(--color-mockup-text)]">
          {title}
        </h2>
      </div>
      {friendships?.length > 0 ? (
        <List className="divide-y">
          {friendships.map(({ friend }) => (
            <ListItem key={friend.id} className="flex items-center gap-3 py-3">
              <ListItemIcon>
                <Avatar
                  alt={friend.firstName + " " + friend.lastName}
                  fallback={
                    (friend.firstName?.[0] ?? "") + (friend.lastName?.[0] ?? "")
                  }
                  className="bg-primary/10 text-primary"
                />
              </ListItemIcon>
              <ListItemText
                primary={friend.firstName + " " + friend.lastName}
              />
            </ListItem>
          ))}
        </List>
      ) : (
        <div className="p-4 text-center">
          <p className="text-body text-[var(--color-mockup-text-mid)]">
            <Translate contentKey="edocendoApp.edoUser.home.notFound" />
          </p>
        </div>
      )}
      <Pagination
        count={totalItems}
        page={paginationState.activePage - 1}
        rowsPerPage={paginationState.itemsPerPage}
        onPageChange={(p) => handlePagination(p + 1)}
        onRowsPerPageChange={handleRowsPerPage}
        labelRowsPerPage="Righe per pagina:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} di ${count !== -1 ? count : "more than" + to}`
        }
      />
    </Card>
  );
};

export default FriendsList;
